import { render, staticRenderFns } from "./RecuperarSenhaNovaSenha.vue?vue&type=template&id=67ec17a8&scoped=true"
import script from "./RecuperarSenhaNovaSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenhaNovaSenha.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenhaNovaSenha.vue?vue&type=style&index=0&id=67ec17a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec17a8",
  null
  
)

export default component.exports